import React from "react";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDisplaySingleEmementStyles } from "../../useDisplaySingleEmementStyles";
import { useAuth } from "../../../data/auth/hooks";
import { useDisplaySecurityValuation } from "../../../data/reports/securityStatistics/hooks/useDisplaySecurityValuation";

export interface DisplaySecurityValuationProps {
  symbol?: string;
}

export const DisplaySecurityValuation: React.FunctionComponent<DisplaySecurityValuationProps> = ({
  symbol,
}) => {
	  const valuation = useDisplaySecurityValuation(symbol);

	const style = useDisplaySingleEmementStyles();
	const { getString, getDateString, getDateTimeString, getFormatedNumberString, getFormatedNumberString4,getPercentString } = React.useContext(
		LocalizationContext
	);

	console.log(valuation)

	const [auth] = useAuth();

	return (
		<div className={style.root}>

			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("marketCapitalization")}</span>
				<span className={style.value}> {getFormatedNumberString4(valuation?.market_capitalization)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("trailingPe")}</span>
				<span className={style.value}> {getFormatedNumberString4(valuation?.trailing_pe, true)}</span>
			</div>			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("forwardPe")}</span>
				<span className={style.value}> {getFormatedNumberString4(valuation?.forward_pe, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("pegRatio")}</span>
				<span className={style.value}> {getFormatedNumberString4(valuation?.peg_ratio, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("revenueTtm")}</span>
				<span className={style.value}> {getFormatedNumberString4(valuation?.revenue_ttm)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("dilutedEpsTtm")}</span>
				<span className={style.value}> {getFormatedNumberString4(valuation?.diluted_eps_ttm, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("profitMargin")}</span>
				<span className={style.value}> {getPercentString(valuation?.profit_margin, false)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("returnOnEquityTtm")}</span>
				<span className={style.value}> {getPercentString(valuation?.return_on_equity_ttm)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("totalDebtToEquityMrq")}</span>
				<span className={style.value}> {getFormatedNumberString4(valuation?.total_debt_to_equity_mrq, true)}</span>
			</div>
		</div>
	);
};

